/*!
	js-cookie
	Copyright	Klaus Hartl, Fagner Brack, GitHub Contributors
	License		MIT
	Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions: The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	Version		3.0.5

	https://github.com/js-cookie/js-cookie
*/
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self,function(){var n=e.Cookies,o=e.Cookies=t();o.noConflict=function(){return e.Cookies=n,o}}())}(this,(function(){"use strict";function e(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)e[o]=n[o]}return e}var t=function t(n,o){function r(t,r,i){if("undefined"!=typeof document){"number"==typeof(i=e({},o,i)).expires&&(i.expires=new Date(Date.now()+864e5*i.expires)),i.expires&&(i.expires=i.expires.toUTCString()),t=encodeURIComponent(t).replace(/%(2[346B]|5E|60|7C)/g,decodeURIComponent).replace(/[()]/g,escape);var c="";for(var u in i)i[u]&&(c+="; "+u,!0!==i[u]&&(c+="="+i[u].split(";")[0]));return document.cookie=t+"="+n.write(r,t)+c}}return Object.create({set:r,get:function(e){if("undefined"!=typeof document&&(!arguments.length||e)){for(var t=document.cookie?document.cookie.split("; "):[],o={},r=0;r<t.length;r++){var i=t[r].split("="),c=i.slice(1).join("=");try{var u=decodeURIComponent(i[0]);if(o[u]=n.read(c,u),e===u)break}catch(e){}}return e?o[e]:o}},remove:function(t,n){r(t,"",e({},n,{expires:-1}))},withAttributes:function(n){return t(this.converter,e({},this.attributes,n))},withConverter:function(n){return t(e({},this.converter,n),this.attributes)}},{attributes:{value:Object.freeze(o)},converter:{value:Object.freeze(n)}})}({read:function(e){return'"'===e[0]&&(e=e.slice(1,-1)),e.replace(/(%[\dA-F]{2})+/gi,decodeURIComponent)},write:function(e){return encodeURIComponent(e).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,decodeURIComponent)}},{path:"/"});return t}));
/*!
	Shopify.formatMoney
	Copyright	Stewart Knapman

	https://gist.github.com/stewartknapman/8d8733ea58d2314c373e94114472d44c
*/
var Shopify=Shopify||{};Shopify.money_format=(typeof general!=='undefined'&&general.currency)?general.currency:'{{amount}}';Shopify.formatMoney=function(cents,format){if(typeof cents=='string'){cents=cents.replace('.','')}
    var value='';var placeholderRegex=/\{\{\s*(\w+)\s*\}\}/;var formatString=(format||this.money_format);function defaultOption(opt,def){return(typeof opt=='undefined'?def:opt)}
    function formatWithDelimiters(number,precision,thousands,decimal){precision=defaultOption(precision,2);thousands=defaultOption(thousands,',');decimal=defaultOption(decimal,'.');if(isNaN(number)||number==null){return 0}
        number=(number/100.0).toFixed(precision);var parts=number.split('.'),dollars=parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,'$1'+thousands),cents=parts[1]?(decimal+parts[1]):'';return dollars+cents}
    switch(formatString.match(placeholderRegex)[1]){case 'amount':value=formatWithDelimiters(cents,2);break;case 'amount_no_decimals':value=formatWithDelimiters(cents,0);break;case 'amount_with_comma_separator':value=formatWithDelimiters(cents,2,'.',',');break;case 'amount_no_decimals_with_comma_separator':value=formatWithDelimiters(cents,0,'.',',');break}
    return formatString.replace(placeholderRegex,value)}

function createElementWithClass(tag, classList) {
    const tagElem = document.createElement(tag);
    if (!Array.isArray(classList)) {
        classList = [classList];
    }
    /*for (var i = 0; i < classList.length; i++) {
        tagElem.classList.add(classList[i])
    }*/
    tagElem.classList.add(...classList);
    return tagElem;
}

// Tabs
function semanticTabs(en) {
	"use strict";
	if (!en || !en.children || en.children.length < 2) return;

	if (en.classList.contains('tabs-initialized')) return;
	en.classList.add('tabs-initialized');
	
	const tabs_header = en.children[0];
	const tabs_content = en.children[1];
	if (!tabs_header || !tabs_content) return;

	const active_class = en.classList.contains('btn') ? 'link-btn' : 'active';
	const custom_active_class = (en.dataset && en.dataset.activeClass) ? en.dataset.activeClass : '';

	const tabs_header_items = tabs_header.querySelectorAll("li");
	const content_items = tabs_content.children;

	const header_len = tabs_header_items.length;
	const content_len = content_items.length;

	const contentByIndex = Object.create(null);
	const accordionHeaderByIndex = Object.create(null);

	for (let i = 0; i < content_len; i++) {
		const item = content_items[i];

		let di = item.getAttribute("data-index");
		if (di === null) {
			di = String(header_len - i);
			item.setAttribute("data-index", di);
		}

		const existingHeader = item.querySelector(".tabs-header");
		const existingInner = item.querySelector(".tabs-inner");
		if (existingHeader && existingInner) {
			contentByIndex[di] = item;
			accordionHeaderByIndex[di] = existingHeader;
			continue;
		}

		const headerLink = document.createElement("a");
		headerLink.href = "#";
		headerLink.className = item.classList.contains('tab-closed') ? 'tabs-header' : 'tabs-header toggle';
		headerLink.textContent = "Tabs Header";

		const inner = document.createElement("div");
		inner.className = "tabs-inner";

		while (item.firstChild) {
			inner.appendChild(item.firstChild);
		}

		item.appendChild(headerLink);
		item.appendChild(inner);

		contentByIndex[di] = item;
		accordionHeaderByIndex[di] = headerLink;
	}

	for (let j = 0; j < header_len; j++) {
		const li = tabs_header_items[j];

		let liDi = li.getAttribute("data-index");
		if (liDi === null) {
			liDi = String(header_len - j);
			li.setAttribute("data-index", liDi);
		}

		const liAnchor = li.querySelector("a");
		if (liAnchor) {
			const aliasHTML = liAnchor.innerHTML;
			const accHeader = accordionHeaderByIndex[liDi];
			if (accHeader) accHeader.innerHTML = aliasHTML;
		}

		if (li.classList.contains(active_class)) {
			li.classList.add('item-active');
		}
	}

	tabs_content.addEventListener('click', (e) => {
		const target = e.target;
		if (!target) return;

		const header = (target.classList && target.classList.contains("tabs-header"))
			? target
			: (target.closest ? target.closest(".tabs-header") : null);

		if (!header || !tabs_content.contains(header)) return;

		header.classList.toggle("toggle");
		e.preventDefault();
	});

	if (!en.classList.contains('static')) {
		let activeIndex = null;

		tabs_header.addEventListener('click', (e) => {
			const target = e.target;
			if (!target) return;

			const link = (target.tagName === 'A')
				? target
				: (target.closest ? target.closest("a") : null);

			if (!link || !tabs_header.contains(link)) return;

			const li = link.closest ? link.closest("li") : null;
			if (!li || !tabs_header.contains(li)) return;

			const d = li.getAttribute("data-index");
			if (!d) return;

			if (activeIndex !== d) {
				for (let k = 0; k < header_len; k++) {
					const item = tabs_header_items[k];
					item.classList.remove(active_class);
					item.classList.remove('item-active');
					item.classList.remove('active'); 
					if (custom_active_class !== '') item.classList.remove(custom_active_class);
				}

				li.classList.add(active_class);
				li.classList.add('item-active');
				if (custom_active_class !== '') li.classList.add(custom_active_class);

				for (let m = 0; m < content_len; m++) {
					content_items[m].classList.add('hidden');
				}

				const activeContent = contentByIndex[d];
				if (activeContent) activeContent.classList.remove('hidden');

				activeIndex = d;
			}

			const href = link.getAttribute('href');
			const inDesignMode = (typeof Shopify !== 'undefined' && Shopify && Shopify.designMode);
			if (href === './' || href === '#' || inDesignMode) {
				e.preventDefault();
			}
		});
	}
}
